import { EPageType } from 'shared/common/types/pageType';

export async function importApp(pageName: EPageType) {
  switch (pageName) {
    case 'm03y26smb': {
      return (await import('shared/m03y26/smb/containers/SmbApp')).SmbM03Y26App;
    }

    case 'm03y26ab': {
      return (await import('shared/m03y26/ab/containers/AbApp')).AbM03Y26App;
    }

    case 'm03y26sob': {
      return (await import('shared/m03y26/sob/containers/SobApp')).SobM03Y26App;
    }

    case 'withRangeM03y26': {
      return (await import('shared/m03y26/withRange/containers/WithRangeApp')).WithRangeM03Y26App;
    }

    default:
      throw new Error('Unknown context.custom.pageName');
  }
}
